import { render, staticRenderFns } from "./VLeaseDeviationsSection.vue?vue&type=template&id=b94b95ae&"
import script from "./VLeaseDeviationsSection.vue?vue&type=script&lang=js&"
export * from "./VLeaseDeviationsSection.vue?vue&type=script&lang=js&"
import style0 from "./VLeaseDeviationsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports